import { z } from 'zod';

export const createSharedLinkSchema = z.object({
  resourceType: z.enum(['meal_plan', 'shopping_list']),
  resourceId: z.string().uuid('Invalid resource ID'),
  expiresInDays: z.number().int().min(1).max(30).default(7),
}).strict();

export type CreateSharedLinkInput = z.infer<typeof createSharedLinkSchema>;
